import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=62494a0b&"
import script from "./h5.vue?vue&type=script&lang=ts&"
export * from "./h5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports